// import components
import { styled, Box, Divider } from '@mui/material';

export const StyledFooterFormActionsBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginLeft: 'auto',
  gap: theme.spacing(2)
}));

export const StyledSettlementsDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(4, 0)
}));
